'use client';

import Image from 'next/image';
import { useState, useCallback, useEffect, useRef } from 'react';

const reviewImages = [
    { src: '/reviews/GradBrew_testimonial_1.webp', alt: 'GradBrew student review 1' },
    { src: '/reviews/GradBrew_testimonial_2.webp', alt: 'GradBrew student review 2' },
    { src: '/reviews/GradBrew_testimonial_3.webp', alt: 'GradBrew student review 3' },
    { src: '/reviews/GradBrew_testimonial_4.webp', alt: 'GradBrew student review 4' },
    { src: '/reviews/GradBrew_testimonial_5.webp', alt: 'GradBrew student review 5' },
    { src: '/reviews/GradBrew_testimonial_6.webp', alt: 'GradBrew student review 6' },
    { src: '/reviews/GradBrew_testimonial_7.webp', alt: 'GradBrew student review 7' },
    { src: '/reviews/GradBrew_testimonial_8.webp', alt: 'GradBrew student review 8' },
    { src: '/reviews/GradBrew_testimonial_9.webp', alt: 'GradBrew student review 9' },
    { src: '/reviews/GradBrew_testimonial_10.webp', alt: 'GradBrew student review 10' },
    { src: '/reviews/GradBrew_testimonial_11.webp', alt: 'GradBrew student review 11' },
];

type TestimonialCarouselProps = {
    autoPlayInterval?: number;
};

export function TestimonialCarousel({ autoPlayInterval = 5000 }: TestimonialCarouselProps) {
    const [current, setCurrent] = useState(0);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const total = reviewImages.length;

    const next = useCallback(() => {
        setCurrent((prev) => (prev + 1) % total);
    }, [total]);

    useEffect(() => {
        timerRef.current = setTimeout(next, autoPlayInterval);
        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [current, next, autoPlayInterval]);

    const main = reviewImages[current];

    if (!main) {
        return null;
    }

    return (
        <div className="home-header_image-wrapper">
            <div className="browser_component">
                <div className="browser_top-bar">
                    <div className="browser_controls">
                        <div className="browser_control"></div>
                        <div className="browser_control"></div>
                        <div className="browser_control"></div>
                    </div>
                </div>
                <div className="browser_window">
                    <Image
                        src={main.src}
                        alt={main.alt}
                        width={1500}
                        height={1500}
                        sizes="(max-width: 1279px) 100vw, 1280px"
                        className="hero_main-image"
                        priority
                        fetchPriority="high"
                    />
                </div>
            </div>
        </div>
    );
}
